import _ from "lodash";
/*eslint import/namespace: ['error', { allowComputed: true }]*/
import reducer, {
  setAssignmentModalData,
  setAssessmentImportModalData,
  setAssessmentSelectModalData,
  setAddNoteModalData,
  setAddLinkModalData,
  setActiveContentData,
  updateDisplaySettings,
  updateFilters,
  resetFilters,
  resetModalState,
  setRightPaneItems,
  setIsActionLoading,
  setMoveToSectionModalData,
  setConfirmationDialogData,
  setIsDragDisabled,
  setCurrentRightPane,
  setOpenAssessmentAIPaneOnMount,
  setWorksheetModalData,
} from "./CommonModules";

// eslint-disable-next-line disable-autofix/import/no-namespace
import * as ENTITY_FLOW_MODULE_FUNCS from "./EntityFlow/Module";
// eslint-disable-next-line disable-autofix/import/no-namespace
import * as LEARNING_COURSE_MODULE_FUNCS from "./LearningCourseFlow/Module";
import { getIsLearningCoursesEnabledForUnit } from "UnitPlans/modules/UnitViewModeUtils";

export const getUnitFlowModuleFuncs = () => {
  const learningCourseModuleFuncs = _.keys(LEARNING_COURSE_MODULE_FUNCS);
  const entityFlowModuleFuncs = _.keys(ENTITY_FLOW_MODULE_FUNCS);

  const moduleSet = new Set([
    ...learningCourseModuleFuncs,
    ...entityFlowModuleFuncs,
  ]);

  const moduleFuncs = {};
  [...moduleSet].forEach(funcName => {
    moduleFuncs[funcName] = args => {
      const isLearningCoursesEnabled = getIsLearningCoursesEnabledForUnit();
      return isLearningCoursesEnabled
        ? LEARNING_COURSE_MODULE_FUNCS[funcName]?.(args)
        : ENTITY_FLOW_MODULE_FUNCS[funcName]?.(args);
    };
  });

  return {
    ...moduleFuncs,
    setWorksheetModalData,
    setAssignmentModalData,
    setAssessmentImportModalData,
    setAssessmentSelectModalData,
    setAddNoteModalData,
    setAddLinkModalData,
    setActiveContentData,
    updateDisplaySettings,
    updateFilters,
    resetFilters,
    resetModalState,
    setRightPaneItems,
    setIsActionLoading,
    setMoveToSectionModalData,
    setConfirmationDialogData,
    setIsDragDisabled,
    setCurrentRightPane,
    setOpenAssessmentAIPaneOnMount,
  };
};

export default reducer;
